/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Dialog_Delete_ItemInputs */

const en_dialog_delete_item = /** @type {(inputs: Dialog_Delete_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete item ${i?.title}`)
};

const es_dialog_delete_item = /** @type {(inputs: Dialog_Delete_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar elemento ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Delete item {title}" |
*
* @param {Dialog_Delete_ItemInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_delete_item = /** @type {((inputs: Dialog_Delete_ItemInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Delete_ItemInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_delete_item(inputs)
	return en_dialog_delete_item(inputs)
});